module.exports = __webpack_public_path__ + "static/assets/0569ad94a9c53e08b2fec166cfebee4a.png";